import { render, staticRenderFns } from "./ExportProjectDataButton.vue?vue&type=template&id=64b60704"
import script from "./ExportProjectDataButton.vue?vue&type=script&lang=js"
export * from "./ExportProjectDataButton.vue?vue&type=script&lang=js"
import style0 from "./ExportProjectDataButton.vue?vue&type=style&index=0&id=64b60704&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports